import React from 'react';
import { FaGithub, FaGlobe, FaStar } from 'react-icons/fa';
import './Projects.css';

const projects = [
  {
    title: 'Bolão Copa 2026',
    description:
      'Aplicação web para gerenciar bolões da Copa do Mundo de 2026. Permite cadastrar palpites, acompanhar pontuação e classificação em tempo real entre os participantes.',
    imageUrl:
      'https://images.unsplash.com/photo-1551958219-acbc608c6377?auto=format&fit=crop&w=800&q=80',
    githubUrl: 'https://github.com/sl4k3r1',
    liveUrl: 'https://bolao-copa2026-roges.vercel.app/',
    tags: ['React', 'JavaScript', 'CSS', 'Vercel'],
    featured: true,
  },
  {
    title: 'Calculadora React',
    description:
      'Calculadora completa para praticar gerenciamento de estado e manipulação de eventos em React.',
    imageUrl:
      'https://github.com/sl4k3r1/sl4k3r1/blob/main/Captura%20de%20tela%202024-07-25%20110423.png?raw=true',
    githubUrl: 'https://github.com/sl4k3r1/calculator',
    liveUrl: 'https://calculator-react-bernardo.vercel.app/',
    tags: ['React', 'JavaScript', 'CSS'],
  },
  {
    title: 'Galeria de Fotos',
    description:
      'Galeria de fotos responsiva desenvolvida em React, com layout dinâmico e visualização em destaque.',
    imageUrl:
      'https://github.com/sl4k3r1/sl4k3r1/blob/main/Captura%20de%20tela%202024-08-06%20095547.png?raw=true',
    githubUrl: 'https://github.com/sl4k3r1/photo-gallery',
    liveUrl: 'https://photo-gallery-bernardo-react.vercel.app/',
    tags: ['React', 'CSS', 'UI'],
  },
  {
    title: 'Lista de Compras',
    description:
      'Aplicativo de lista de compras com adição, remoção e marcação de itens, ideal para o uso no dia a dia.',
    imageUrl:
      'https://github.com/sl4k3r1/sl4k3r1/blob/main/Captura%20de%20tela%202024-08-06%20100822.png?raw=true',
    githubUrl: 'https://github.com/sl4k3r1/shopping-list',
    liveUrl: 'https://shopping-list-bernardo-react.vercel.app/',
    tags: ['React', 'JavaScript', 'Hooks'],
  },
];

const Projects = () => {
  return (
    <section id="projects" className="section reveal">
      <div className="section-header">
        <h2 className="section-title">Projetos</h2>
        <span className="section-subtitle">
          Algumas das aplicações que desenvolvi recentemente
        </span>
      </div>

      <div className="projects-container">
        {projects.map((project, index) => (
          <article
            className={`project-card ${project.featured ? 'featured' : ''}`}
            key={index}
          >
            {project.featured && (
              <span className="project-badge">
                <FaStar /> Mais recente
              </span>
            )}

            <div className="project-image-wrapper">
              <img
                src={project.imageUrl}
                alt={`Captura de tela do projeto ${project.title}`}
                loading="lazy"
              />
              <div className="project-overlay">
                <div className="project-links">
                  <a
                    href={project.githubUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={`Repositório do ${project.title}`}
                  >
                    <FaGithub /> Código
                  </a>
                  <a
                    href={project.liveUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={`Demo ao vivo do ${project.title}`}
                  >
                    <FaGlobe /> Acessar
                  </a>
                </div>
              </div>
            </div>

            <div className="project-content">
              <h3>{project.title}</h3>
              <p>{project.description}</p>
              <div className="project-tags">
                {project.tags.map((tag, i) => (
                  <span className="project-tag" key={i}>
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};

export default Projects;
